import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import GoogleMapReact from "google-map-react";
import { geoCodingAddress } from "../../api";
import { Link } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  bar: {
    height: "15px",
    verticalAlign: "bottom",
    display: "flex",
    textAlign: "center",
  },
});

const defaultProps = {
  center: {
    lat: 39.95917,
    lng: -75.19842,
  },
  zoom: 11,
};

const MarkerClinic = ({ text, title }) => (
  <div
    title={title}
    style={{
      color: "white",
      background: "grey",
      padding: "5px 5px",
      display: "inline-flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      transform: "translate(-50%, -50%)",
    }}
  >
    {text}
  </div>
);

const PhysiciansReportControl = ({ loot, value, zip }) => {
  const [mapCenter, setMapCenter] = useState({
    lat: 39.95917,
    lng: -75.19842,
  });

  const classes = useStyles();

  useEffect(() => {
    const getMapCenter = async () => {
      const result = await geoCodingAddress(zip);
      console.log("geoCodingAddress: ", result, zip);
      setMapCenter({
        lat: result.addresses[0].latitude,
        lng: result.addresses[0].longitude,
      });
    };
    getMapCenter();
  }, []);

  const generatePhysiciansListTable = (target) => {
    const physiciansList = [];
    if (target.physiciansNearBy) {
      for (let i = 0; i < target.physiciansNearBy.length; i++) {
        const npi = target.physiciansNearBy[i].npi;
        const fullName =
          target.physiciansNearBy[i].lastName +
          " " +
          target.physiciansNearBy[i].firstName;
        const fullAddress =
          target.physiciansNearBy[i].addr +
          " " +
          target.physiciansNearBy[i].city +
          " " +
          target.physiciansNearBy[i].state +
          " " +
          target.physiciansNearBy[i].zip;
        const phoneNumber = target.physiciansNearBy[i].phone;
        physiciansList.push({ npi, fullName, fullAddress, phoneNumber });
      }
    }
    return physiciansList;
  };

  const generateClinicsListTable = (target) => {
    const clinics = [];
    if (target.clinicsNearBy) {
      for (let i = 0; i < target.clinicsNearBy.length; i++) {
        const id = i;
        const fullName = target.clinicsNearBy[i].hospitalName;
        const fullAddress =
          target.clinicsNearBy[i].address +
          " " +
          target.clinicsNearBy[i].city +
          " " +
          target.clinicsNearBy[i].state +
          " " +
          target.clinicsNearBy[i].zip;
        const phoneNumber = target.clinicsNearBy[i].phone;
        const lanLong = target.clinicsNearBy[i].lanLong;
        clinics.push({ fullName, fullAddress, phoneNumber, lanLong });
      }
    }
    return clinics;
  };

  switch (value) {
    case 0:
      return (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Name</StyledTableCell>
                <StyledTableCell align="right">Location</StyledTableCell>
                <StyledTableCell align="right">Phone</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {generatePhysiciansListTable(loot).map((row) => (
                <StyledTableRow key={row.npi}>
                  <StyledTableCell component="th" scope="row">
                    <Link href={'https://linkmedicine.com/view-physician/?npi=' + row.npi} target="_blank"> {row.fullName}</Link>                   
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row">
                    {row.fullAddress}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.phoneNumber}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    case 1:
      return (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Name</StyledTableCell>
                <StyledTableCell align="right">Location</StyledTableCell>
                <StyledTableCell align="right">Phone</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {generateClinicsListTable(loot).map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell component="th" scope="row">
                    {row.fullName}
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row">
                    {row.fullAddress}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.phoneNumber}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    case 2:
      return (
        <div style={{ height: "30vh", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyDKhjLxJXb4x2cKu5dlrCqTphk-LmuaFys",
            }}
            center={mapCenter}
            defaultZoom={defaultProps.zoom}
          >
            {generateClinicsListTable(loot).map((row) => {
              console.log("generateClinicsListTable row: ", row);
              const lonlat = row.lanLong.split(",");
              return (
                <MarkerClinic
                  lat={lonlat[0]}
                  lng={lonlat[1]}
                  text="H"
                  title={row.hospitalName}
                />
              );
            })}
          </GoogleMapReact>
        </div>
      );
    default:
      return <div>map</div>;
  }
};

PhysiciansReportControl.propTypes = {
  loot: PropTypes.array.isRequired,
  value: PropTypes.number.isRequired,
};
export default PhysiciansReportControl;



// WEBPACK FOOTER //
// ./src/components/PhysiciansReportControl/PhysiciansReportControl.js